import type { ColumnFiltersState } from "@tanstack/react-table";

/**
 * Merges externally-enforced column filters (e.g. from a scope toggle) into the
 * current table filter state. Each enforced entry replaces that column's filter,
 * or clears it when the value is an empty array. Filters on other columns are
 * left untouched.
 */
export const reconcileEnforcedColumnFilters = (
	current: ColumnFiltersState | null | undefined,
	enforced: ColumnFiltersState,
): ColumnFiltersState => {
	let next = current ?? [];
	for (const filter of enforced) {
		const others = next.filter((existing) => existing.id !== filter.id);
		next = Array.isArray(filter.value) && filter.value.length === 0 ? others : [...others, filter];
	}
	return next;
};
